import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (checked && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail || "Login failed.";
      toast.error(typeof detail === "string" ? detail : "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#0a0a0a] text-white">
      {/* Left visual */}
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_asphalt-studio/artifacts/yvu5kx0p_Chevron.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-black/70" />
        <div className="absolute bottom-10 left-10 max-w-md">
          <div className="text-[10px] tracking-[0.32em] uppercase text-[#A3A3A3] mb-3">
            HighwaysLens · Studio Admin
          </div>
          <div className="font-display text-3xl tracking-tight">
            Manage briefs, gallery and films from one place.
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-sm"
          data-testid="admin-login-form"
        >
          <div className="text-[10px] tracking-[0.32em] uppercase text-[#4A6D8C] mb-4">
            Sign in
          </div>
          <h1 className="font-display text-3xl tracking-tight mb-8">
            Studio access
          </h1>

          <label className="text-[10px] tracking-[0.28em] uppercase text-[#737373]">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="hl-input"
            placeholder="you@studio.com"
            data-testid="login-email"
            autoFocus
          />

          <label className="text-[10px] tracking-[0.28em] uppercase text-[#737373] mt-6 block">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="hl-input"
            placeholder="••••••••"
            data-testid="login-password"
          />

          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="hl-btn-primary mt-10 w-full disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <div className="text-[11px] text-[#525252] mt-6 leading-relaxed">
            Studio admin only. If you've forgotten your password, contact your
            developer.
          </div>
        </form>
      </div>
    </div>
  );
}
